<div class="profile-treatments-container public-profile-card" *ngIf="showCard">
    <div class="card-container">
        
        <!-- Card -->
        <mat-card *ngIf="finishLoading">

            <!-- Header -->
            <mat-card-header>
                <mat-icon fontSet="phr-iconset" class="phr-iconset-procedimientos"></mat-icon>
                <span class="header-title">{{ 'publicProfiles.treatments.headerTitle' | translate:locale.language }}</span>            
            </mat-card-header>
            
            <div class="header-separator"></div>

            <!-- Content -->
            <mat-card-content class="">
                <div class="treatment-container" [ngClass]="{'limited-treatment': !showMore}">
                    <div class="treatment-item" *ngFor="let treatment of publicProfile.tratamientos; index as i; trackBy: trackById">
                        <mat-icon fontSet="phr-iconset" class="phr-iconset-star" [ngClass]="{'highlighted' : treatment.detalleDestacado == 'S' }"></mat-icon>                        
                        <span>{{treatment.objetoDetalle}}</span>
                    </div>
                </div>
                <div class="col s12 m12 show-more-container" *ngIf="publicProfile.tratamientos.length > 5">
                    <div *ngIf="showMore" (click)="showMore = !showMore;">
                        <span>{{ 'publicProfiles.treatments.showLess' | translate:locale.language }}</span>
                    </div>
                    <div *ngIf="!showMore" (click)="showMore = !showMore;">
                        <span>{{ 'publicProfiles.treatments.showMore' | translate:locale.language }}</span>
                    </div>
                </div>
            </mat-card-content>

        </mat-card>

        <!-- Skeleton -->
        <mat-card class="skeleton-card" *ngIf="!finishLoading">
            <mat-card-header>
                <span class="header-title">
                    <ngx-skeleton-loader [theme]="{ 'width': '190px', 'height': '17px', 'background-color': 'rgb(231, 231, 232)', 'border-radius': '2px', 'margin-bottom': '0px'}"></ngx-skeleton-loader>         
                </span>
            </mat-card-header>
            
            <div class="header-separator"></div>
            
            <mat-card-content class="">
                <div class="treatment-container">
                    <div class="treatment-item">
                        <ngx-skeleton-loader [theme]="{ 'width': '150px', 'height': '16px', 'background-color': 'rgba(83, 86, 90, 0.14)' }"></ngx-skeleton-loader>        
                    </div>
                    <div class="treatment-item">
                        <ngx-skeleton-loader [theme]="{ 'width': '100px', 'height': '16px', 'background-color': 'rgba(83, 86, 90, 0.14)' }"></ngx-skeleton-loader>        
                    </div>
                    <div class="treatment-item">
                        <ngx-skeleton-loader [theme]="{ 'width': '130px', 'height': '16px', 'background-color': 'rgba(83, 86, 90, 0.14)' }"></ngx-skeleton-loader>        
                    </div>
                    <div class="treatment-item">
                        <ngx-skeleton-loader [theme]="{ 'width': '80px', 'height': '16px', 'background-color': 'rgba(83, 86, 90, 0.14)' }"></ngx-skeleton-loader>        
                    </div>
                </div>
            </mat-card-content>
        </mat-card>

    </div>    
</div>



